export default "__VITE_ASSET__D922D6t3__"